/* -------------------------------------------------
   BS MENU MOBILE: tab Donna/Uomo nel drawer
   (struttura ref. Paskal, adattata Brancaccio)
-------------------------------------------------- */
(function () {
  'use strict';

  function applyGender(g) {
    document.querySelectorAll('.bs-mnav-tab').forEach(function (t) {
      var on = t.getAttribute('data-bs-gender') === g;
      t.classList.toggle('bs-mnav-tab--active', on);
      // colore del pallino inline: alcuni engine non riapplicano le regole
      // discendenti dopo lo spostamento del drawer nel DOM
      var dot = t.querySelector('.bs-mnav-tab__dot');
      if (dot) {
        dot.style.background = on ? '#CD121F' : 'transparent';
        dot.style.borderColor = on ? '#CD121F' : '#c9c9c6';
      }
    });
    document.querySelectorAll('[data-bs-mnav-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-bs-mnav-panel') !== g;
    });
  }

  function savedGender() {
    try { return localStorage.getItem('bs_gender') || 'donna'; } catch (e) { return 'donna'; }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.bs-mnav-tab');
    if (!tab) return;
    e.preventDefault();
    var g = tab.getAttribute('data-bs-gender');
    try { localStorage.setItem('bs_gender', g); } catch (err) {}
    applyGender(g);
  });

  // il drawer viene iniettato dal tema all'apertura: inizializza i tab quando compare
  var mo = new MutationObserver(function () {
    var tabs = document.querySelector('.bs-mnav-tabs');
    if (tabs && !document.querySelector('.bs-mnav-tab--active')) {
      applyGender(savedGender());
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Symmetry broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
*   4.  on:cart:after-merge
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - selectedOptions: an array of currently selected options (e.g. ['Blue', 'Large'])
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:after-merge
 * -------------------------------------------------------------------------------------------------
 * Fires after a list of cart items has finished being dynamically updated after a cart change.
 *
 * How to listen:
 * document.addEventListener('on:cart:after-merge', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Symmetry utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Symmetry has no third-party JavaScript dependencies.
 *
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */

/* -------------------------------------------------
   BS INFINITE SCROLL nelle collection (ref. Paskal)
   - Carica la pagina successiva quando ci si avvicina al fondo
   - Aggiorna page=N nell'URL in base al primo prodotto visibile
     (aumenta scendendo, diminuisce risalendo)
   - Compatibile con il filtering AJAX del tema (si reinizializza
     quando cambiano i filtri; il contenitore paginazione persiste)
-------------------------------------------------- */
(function () {
  'use strict';

  if (!location.pathname.includes('/collections/')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__BS_INFINITE__) return;
  window.__BS_INFINITE__ = true;

  var state = { key: null, nextUrl: null, loading: false };

  function filterKey() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('page');
      return u.pathname + '?' + u.searchParams.toString();
    } catch (e) { return location.pathname; }
  }

  function readNextUrl(root) {
    var el = (root || document).querySelector('.pagination__next');
    if (!el) return null;
    try { return new URL(el.getAttribute('href'), location.href).toString(); } catch (e) { return null; }
  }

  function initState() {
    state.key = filterKey();
    state.loading = false;
    state.nextUrl = readNextUrl(document);
    var grid = document.querySelector('.collection-listing .product-grid');
    if (grid) {
      var p = 1;
      try { p = parseInt(new URL(location.href).searchParams.get('page') || '1', 10); } catch (e) {}
      for (var i = 0; i < grid.children.length; i++) {
        if (!grid.children[i].hasAttribute('data-bs-page')) {
          grid.children[i].setAttribute('data-bs-page', p);
        }
      }
    }
  }

  function setUrlPage(p) {
    try {
      var u = new URL(location.href);
      if (p > 1) { u.searchParams.set('page', p); } else { u.searchParams.delete('page'); }
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }

  function stripAnimations(el) {
    if (el.nodeType !== 1) return;
    el.removeAttribute('data-cc-animate');
    el.removeAttribute('data-cc-animate-delay');
    var animated = el.querySelectorAll('[data-cc-animate]');
    for (var i = 0; i < animated.length; i++) {
      animated[i].removeAttribute('data-cc-animate');
      animated[i].removeAttribute('data-cc-animate-delay');
    }
  }

  function loadNext() {
    if (state.loading || !state.nextUrl) return;
    state.loading = true;

    var row = document.querySelector('.pagination-row');
    var loader = document.createElement('div');
    loader.className = 'bs-infinite-loader';
    if (row) row.appendChild(loader);

    var pageNr = 1;
    try { pageNr = parseInt(new URL(state.nextUrl).searchParams.get('page') || '1', 10); } catch (e) {}

    fetch(state.nextUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.collection-listing .product-grid');
        var grid = document.querySelector('.collection-listing .product-grid');
        if (newGrid && grid) {
          while (newGrid.firstElementChild) {
            var el = newGrid.firstElementChild;
            newGrid.removeChild(el);
            stripAnimations(el);
            el.setAttribute('data-bs-page', pageNr);
            grid.appendChild(el);
          }
        }
        state.nextUrl = readNextUrl(doc);
        state.loading = false;
        if (loader.parentNode) loader.parentNode.removeChild(loader);
      })
      .catch(function () {
        state.loading = false;
        if (loader.parentNode) loader.parentNode.removeChild(loader);
      });
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        if (filterKey() !== state.key) initState();
        loadNext();
      }
    }
  }, { rootMargin: '600px 0px' });

  function bindObserver() {
    var row = document.querySelector('.pagination-row');
    if (row) io.observe(row);
  }

  var scrollTick = null;
  function updateUrlByScroll() {
    if (scrollTick) return;
    scrollTick = setTimeout(function () {
      scrollTick = null;
      if (filterKey() !== state.key) return;
      var blocks = document.querySelectorAll('.collection-listing .product-grid > [data-bs-page]');
      var current = null;
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].getBoundingClientRect().bottom > 140) { current = blocks[i]; break; }
      }
      if (!current) return;
      var p = parseInt(current.getAttribute('data-bs-page'), 10) || 1;
      var urlPage = 1;
      try { urlPage = parseInt(new URL(location.href).searchParams.get('page') || '1', 10); } catch (e) {}
      if (p !== urlPage) setUrlPage(p);
    }, 250);
  }

  function start() {
    if (!document.querySelector('.collection-listing .product-grid')) return;
    document.documentElement.classList.add('bs-infinite');
    initState();
    bindObserver();
    // il contenitore paginazione persiste ai refresh AJAX del tema,
    // ma per sicurezza ri-agganciamo periodicamente (observe e' idempotente)
    setInterval(bindObserver, 4000);
    document.addEventListener('scroll', updateUrlByScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
